import { CheckIcon, XIcon } from 'lucide-react';
import { FC } from 'react';
import type { RunStatus } from '@/entities/jobs';

type RunCircleIconProps = {
  status: RunStatus;
};

// Иконка внутри кружка результата пайплайна
export const RunCircleIcon: FC<RunCircleIconProps> = ({ status }) => {
  switch (status) {
    case 'SUCCESS':
      return <CheckIcon className="size-3" strokeWidth={3} />;
    case 'FAILED':
      return <XIcon className="size-3" strokeWidth={3} />;
    case 'CANCELLED':
      return <XIcon className="size-3" strokeWidth={3} />;
    default:
      return null;
  }
};
